module.exports = __webpack_public_path__ + "img/18.e2fa8400.jpg";